import {RouteDefinition} from '../../../routes';
import {BridgeDeviceTypeListScreen} from './BridgeDeviceTypeListScreen';

export const BridgeDeviceTypeSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/developer/bridge-device-type',
        component: BridgeDeviceTypeListScreen,
    },
];
